import React, { FC } from "react";

export const DecidiTuDescriptionText: FC = () => {
  return (
    <>
      Scoperto: è la somma a carico dell’assicurato dedotta dall’importo che la compagnia paga per le spese di sinistri
      liquidati a termini di polizza
    </>
  );
};

export const DecidiTuDescription = React.memo(DecidiTuDescriptionText);
